import { GetAllAccountGroups, GetAllColors, GetAllDaybooks, GetAllHSNCode, GetAllItem, GetAllItemCategory, GetAllLabelClaims, GetAllMfgLicMaster, GetAllPackingMaterialDropdown, GetAllPackingMaterialSize, GetAllPartyDropdown, GetAllPMCategory, GetAllProductDropdown, GetAllProductionStageMaster, GetAllPunchSizes, GetAllRMCategory, GetAllRMDropdown, GetAllStates, GetAllStereoData, GetAllStorageConditions, GetAllTestMaster, GetAllTransportCourier, GetCompanyDetails, GetPartyCorrspAddressById } from "../ApiEndPoints.js";
import { axiosGetWithencryption } from "../AxiosRequests.js";

export default class CommonServices {

    async getAllItemCategory(request) {
        return axiosGetWithencryption(GetAllItemCategory, request);
    }

    async getAllHSNCode(request) {
        return axiosGetWithencryption(GetAllHSNCode, request);
    }

    async getAllStorageConditions(request) {
        return axiosGetWithencryption(GetAllStorageConditions, request);
    }

    async getAllRMCategory(request) {
        return axiosGetWithencryption(GetAllRMCategory, request);
    }

    async getAllPMCategory(request) {
        return axiosGetWithencryption(GetAllPMCategory, request);
    }

    async getAllPackingMaterialSize(request) {
        return axiosGetWithencryption(GetAllPackingMaterialSize, request);
    }

    async getAllStates(request) {
        return axiosGetWithencryption(GetAllStates, request);
    }

    async getAllStereoData(request) {
        return axiosGetWithencryption(GetAllStereoData, request);
    }

    async getAllLabelClaims(request) {
        return axiosGetWithencryption(GetAllLabelClaims, request);
    }

    async getAllColors(request) {
        return axiosGetWithencryption(GetAllColors, request);
    }

    async getAllTestMaster(request) {
        return axiosGetWithencryption(GetAllTestMaster, request);
    }

    async getAllMfgLicMaster(request) {
        return axiosGetWithencryption(GetAllMfgLicMaster, request);
    }

    async getAllProductionStageMaster(request) {
        return axiosGetWithencryption(GetAllProductionStageMaster, request);
    }

    async getAllPunchSizes(request) {
        return axiosGetWithencryption(GetAllPunchSizes, request);
    }

    async getAllAccountGroups(request) {
        return axiosGetWithencryption(GetAllAccountGroups, request);
    }

    async getAllTransportCourier(request) {
        return axiosGetWithencryption(GetAllTransportCourier, request);
    }

    async getAllDaybooks(request) {
        return axiosGetWithencryption(GetAllDaybooks, request);
    }

    async getAllPartyDropdown(request) {
        return axiosGetWithencryption(GetAllPartyDropdown, request);
    }
    async getPartyCorrspAddressById(request) {
        return axiosGetWithencryption(GetPartyCorrspAddressById, request);
    }
    async getAllItem(request) {
        return axiosGetWithencryption(GetAllItem, request);
    }
    async getAllProductDropdown(request) {
        return axiosGetWithencryption(GetAllProductDropdown, request);
    }
    async getAllRMDropdown(request) {
        return axiosGetWithencryption(GetAllRMDropdown, request);
    }
    async getAllPackingMaterialDropdown(request) {
        return axiosGetWithencryption(GetAllPackingMaterialDropdown, request);
    }
    async getCompanyDetails(request) {
        return axiosGetWithencryption(GetCompanyDetails, request);
    }
}

